module.exports = __webpack_public_path__ + "img/logo-login.42e7cc82.png";